import apiUrl from '../../../constants'
import axios from 'axios'
import VueBarcode from 'vue-barcode'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import {Validator} from 'vee-validate'
import orderdetails from './orderdetails/index.vue';
import outQCdetails from './outQCdetails/index.vue';
import packingdetails from './packingdetails/index.vue';
import shippingdetails from './shippingdetails/index.vue';
import pickingdetails from './pickingdetails/index.vue';
import orderItemDetails from './orderItemDetails/index.vue';

export default {
	name: 'PO',
	components: {
		'first': orderdetails,
		'second': orderItemDetails,
		'third': pickingdetails,
		'fourth': outQCdetails,
		'fifth': packingdetails,
		'six': shippingdetails,
	},

	data() {
		return {
			countObj: {},
			currentTab: 'First',
			componentKey: 0,
			type: '',
			tabs: [{
					key: 'First',
					value: 'Order Details'
				},
				{
					key: 'Second',
					value: 'Order Item Details'
				},
				{
					key: 'Third',
					value: 'Picking Details'
				},
				{
					key: 'Fourth',
					value: 'Out QC Details'
				},
				{
					key: 'Fifth',
					value: 'Packing Details'
				},
				{
					key: 'Six',
					value: 'Shipping Details'
				},
			],
		}
	},
	created: function() {

	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1;
			return this.currentTab.toLowerCase()
		},
	},
	mounted() {
		// this.type = this.$route.query.myprop;
	},
	methods: {



	}
}



// WEBPACK FOOTER //
// ./src/views/components/orderdetailstab/orderdetailstab.component.js